import React, { useRef } from "react";
import { RCCDropDownItem, RCCGrid, RCCIcon, RCCInput, arrayMove } from "react-common-components";
import OptionsColumn from "src/components/DefaultColumnsList/Options";
import Select from "src/components/Select";
import {horizontalListSortingStrategy } from "src/components/Sortable/Container/strategy";
import SortableHandle from "src/components/Sortable/Handle";
import SortableItem from "src/components/Sortable/Item";
import { useTranslation } from "src/context/Translations/context";
import { css } from "styled-components";
import { v4 } from "uuid";
import SortableContainer from "src/components/Sortable/Container";
import { columnsTypes, IColumnsTab, IWdtba003,IRefconfigColumnModal } from "../../interface";
import { FieldOnRight } from "../../styles";
import ConfigColumnModal from "./components/configColumnModal";

const TabCollumns: React.FC<IColumnsTab> = ({ 
	columns,
	setColumns,
	register,
	control,
	errors,
	setValue,
	unregister,
	getValues
}) => {
	const { translate} = useTranslation();
	const refModal = useRef<IRefconfigColumnModal>(null);
	type GridSize = "auto" | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

	const remove = (id: string,index: number) => {
		unregister(`columns.${index}`);
		setValue("columns",columns.filter((x) => x.id!==id));
		setColumns(columns.filter((x) => x.id!==id));
	};

	const handleDragEnd = (activeId: string, overId: string) => {
		const activeIndex = columns.findIndex((field) => field.id === activeId);
		const overIndex = columns.findIndex((field) => field.id === overId);

		let temp = [...columns];
		temp= arrayMove(temp, 
			activeIndex, 
			overIndex
		);

		temp = temp.map((col,index) => ({...col,wda003Ordem:index+1}));
		unregister("columns");
		setColumns(temp);
		setValue("columns",temp);
	};
	
	return(
		<RCCGrid container item 
			justifyContent="center">
			<RCCGrid container item
				xs={12} 
				lg={10} 
				styleInline={css`
					&.MuiGrid-root {				
						margin-bottom:15px;
					}
									
				`}
			>
				<SortableContainer 
					onDragEnd={handleDragEnd}
					strategy={horizontalListSortingStrategy}
					items={[...columns]}
				>
						
					{columns.map((column:IWdtba003) => (
						<RCCGrid 
							container 
							item 
							key={v4()}
							xs={parseInt(column.wda003Tamanho.toString(),10) as GridSize}
							direction="column"
							styleInline={css`
									&.MuiGrid-root {
										padding: 4px;
									}
									
									.sortable-handle{
										height:100%;
									}
								`}
						>
							<SortableItem id={column.id} key={v4()} styles={{width:"100%",height:"100%"}}>
								<SortableHandle >
									<RCCGrid 
										item
										container
										justifyContent="center"
										alignContent="center"
										styleInline={css`
											height: 100%;
											cursor:move;
											background:var(--card-background);
											box-shadow: 0 1px 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%); 
											border: 1px solid var(--border-color);
											border-left: none;
											font-size: 0.82rem;
											&.MuiGrid-root {
												padding: 5px;
											}
										`}
									>
										<span>{column.wda003Label}</span>
									</RCCGrid>
								</SortableHandle>
							</SortableItem>
						</RCCGrid>	
					))}
				</SortableContainer> 
			</RCCGrid>
			{columns.map((column:IWdtba003,index) => 
				<RCCGrid container item 
					xs={12} 
					lg={10} 
					key={v4()}
				>
					
					<RCCGrid container item>
						<RCCGrid container item 
							sm={3}
							xs={12}
							styleInline={FieldOnRight}
						>
							<RCCInput
								name={`columns[${index}].wda003Nomecoluna`}
								label={translate("Nome")}
								register={register}
								defaultValue={column.wda003Nomecoluna}
								error = {errors.columns && errors?.columns[index]?.wda003Nomecoluna}
								readOnly
								required
								maxLength={40}
							/>
							<input 
								{...register(`columns[${index}].id`)} 
								name={`columns[${index}].id`}
								value={column.id}
								type="hidden"
							/>	
							<input 
								{...register(`columns[${index}].wda003Id`)} 
								name={`columns[${index}].wda003Id`}
								value={column.wda003Id}
								type="hidden"
							/>	
							<input 
								{...register(`columns[${index}].wda003Ordem`)} 
								name={`columns[${index}].wda003Ordem`}
								value={column.wda003Ordem}
								type="hidden"
							/>	
						</RCCGrid>
						<RCCGrid container item 
							sm={3}
							xs={12}
							styleInline={FieldOnRight}
						>
							<RCCInput
								name={`columns[${index}].wda003Label`}
								label={translate("Label")}
								register={register}
								defaultValue={column.wda003Label}
								error = {errors.columns && errors?.columns[index]?.wda003Label}
								required
								maxLength={120}
								onBlurCapture={(e) => {
									setColumns((prevState) => prevState.map((x) => {
										if(x.id===column.id)
											return {...x,wda003Label:e.target.value};
										return x;
									}));
								}}
							/>
						</RCCGrid>
						<RCCGrid container item 
							sm={2}
							xs={12}
							styleInline={FieldOnRight}
						>
							<Select
								control={control}
								name={`columns[${index}].wda003Tipocoluna`}
								label={translate("Tipo")}
								required
								defaultValue={column.wda003Tipocoluna||columnsTypes.ALFA_NUMERIC}
								error = {errors.columns && errors?.columns[index]?.wda003Tipocoluna}
								options={[
									{value:columnsTypes.ALFA_NUMERIC,label:translate("Alfanumérico")},
									{value:columnsTypes.DATE,label:translate("Data")},
									{value:columnsTypes.NUMERIC,label:translate("Numérico")},
									{value:columnsTypes.HTML,label:translate("Htlm")}
								]}
							/>
						</RCCGrid>
						
						<RCCGrid container item 
							sm={2}
							xs={10}
							styleInline={FieldOnRight}
						>
							<Select
								control={control}
								name={`columns[${index}].wda003Tamanho`}
								label={translate("Tamanho")}
								required
								defaultValue={column.wda003Tamanho.toString()}
								error = {errors.columns && errors?.columns[index]?.wda003Tamanho}
								options={[
									{ value: "1", label: "1" },
									{ value: "2", label: "2" },
									{ value: "3", label: "3" },
									{ value: "4", label: "4" },
									{ value: "5", label: "5" },
									{ value: "6", label: "6" },
									{ value: "7", label: "7" },
									{ value: "8", label: "8" },
									{ value: "9", label: "9" },
									{ value: "10", label: "10" },
									{ value: "11", label: "11" },
									{ value: "12", label: "12" }
								]}
								onChangeCapture={(e) => {
									setColumns((prevState) => prevState.map((x) => {
										if(x.id===column.id)
											return {...x,wda003Tamanho:parseInt(e.value, 10)};
										return x;
									}));
								}}
							/>
						</RCCGrid>
						<RCCGrid container item xs={2} justifyContent="flex-end" alignContent="center">
							<OptionsColumn>
								<RCCDropDownItem 
									selfEnclose
									onClick={() => { 
										refModal?.current?.actionOpen(index,column.wda003Nomecoluna);
									}}
								>
									<RCCIcon 
										name="settings" 
									/>
									{translate("Formatar coluna")}
								</RCCDropDownItem>
								<RCCDropDownItem
									selfEnclose
									onClick={() => {remove(column.id,index);}}
								>
									<RCCIcon 
										name="trash" 
									/>
									{translate("Remover coluna")}
								</RCCDropDownItem>
							</OptionsColumn>
						</RCCGrid>
						<RCCGrid container item>
						</RCCGrid>
					</RCCGrid> 
					<hr/>
				</RCCGrid>
			)}	
			<ConfigColumnModal 
				ref={refModal}
				columns={columns}
				setColumns={setColumns}
				unregister={unregister}
				control={control}
				errors={errors}
				register={register}
				setValue={setValue}
				getValues={getValues}
			/>
		</RCCGrid>
	);
};
export default TabCollumns;
